/* PANETTO TREND – Independent Premium Theme V1
   Eigenes, abhängigkeitsfreies JavaScript. Alles ist progressive enhancement:
   ohne JS funktionieren Navigation, Warenkorb-Formular und Produktformular weiter. */
(function () {
  'use strict';

  /* ---- Sanftes Einblenden (IntersectionObserver) ---- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Hinweis "Versand immer kostenlos": beim Ankommen in einer Kategorie, einmal pro Kategorie und Sitzung ---- */
  function initShipToast() {
    var el = document.querySelector('[data-shiptoast]');
    if (!el) return;
    var key = 'shiptoast:' + (el.getAttribute('data-key') || 'x'), seen = false;
    try { seen = window.sessionStorage.getItem(key) === '1'; } catch (e) {}
    if (seen) return;
    var timer = null;
    function hide() { if (timer) { clearTimeout(timer); timer = null; } el.classList.remove('is-visible'); window.setTimeout(function () { el.hidden = true; }, 400); }
    window.setTimeout(function () {
      el.hidden = false;
      window.requestAnimationFrame(function () { el.classList.add('is-visible'); });
      try { window.sessionStorage.setItem(key, '1'); } catch (e) {}
      timer = window.setTimeout(hide, 7000);
    }, 1200);
    var btn = el.querySelector('[data-shiptoast-close]');
    if (btn) btn.addEventListener('click', hide);
  }

  /* ---- Header: Linie beim Scrollen, mobiles Menü schließen ---- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    /* Zwei Zustaende mit Hysterese (kompakt ab 80 px, gross erst wieder unter 24 px), damit die Hoehenaenderung selbst keinen Wechsel ausloest.
       Scroll-Handler laeuft hoechstens einmal pro Frame (requestAnimationFrame) und ist passiv. */
    var ticking = false;
    var apply = function () {
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;
      header.classList.toggle('is-scrolled', y > 8);
      if (header.classList.contains('is-compact')) { if (y < 24) header.classList.remove('is-compact'); }
      else if (y > 80) header.classList.add('is-compact');
    };
    var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(apply); } };
    apply();
    /* Uebergaenge erst nach dem ersten Frame aktivieren: kein sichtbares Animieren/Flackern beim Laden (z. B. Reload mitten auf der Seite). */
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { header.classList.add('header--ready'); }); });
    window.addEventListener('scroll', onScroll, { passive: true });
    var menu = document.querySelector('[data-mobile-menu]');
    if (menu) {
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menu.removeAttribute('open'); });
      menu.addEventListener('toggle', function () {
        document.documentElement.style.overflow = menu.open ? 'hidden' : '';
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) {
        if (m.matches) menu.removeAttribute('open');
      });
      /* V1.40: Handy/Tablet. Das Navigationsband hat kein Dropdown. Ein Tipp auf einen Punkt MIT Unterpunkten (z. B. "Shop") oeffnet
         stattdessen das Menue und zeigt dessen Unterpunkte (T-Shirts, Poster ...), statt auf die Zielseite des Punktes zu springen.
         Ohne JavaScript bleibt es ein normaler Link. Am Desktop (ab 990 px) aendert sich nichts. */
      document.addEventListener('click', function (e) {
        var link = e.target.closest ? e.target.closest('[data-nav-parent] > .nav__link') : null;
        if (!link || window.matchMedia('(min-width: 990px)').matches) return;
        if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        menu.open = true;
        var title = link.textContent.trim();
        var items = menu.querySelectorAll('.mobile-menu__panel > ul > li');
        for (var i = 0; i < items.length; i++) {
          var a = items[i].querySelector(':scope > a');
          if (a && a.textContent.trim() === title) { window.requestAnimationFrame(function (li) { return function () { li.scrollIntoView({ block: 'start' }); }; }(items[i])); break; }
        }
      });
    }
  }

  /* ---- Startseite: Kategorie-Bilder bewegen sich beim Scrollen leicht im Rahmen (Parallax, wie bei Armani) ----
     Nur mit JS und nur ohne "Bewegung reduzieren": ohne diese Klasse bleiben die Bilder ruhig und unveraendert.
     Der Scroll-Handler laeuft hoechstens einmal pro Frame, ist passiv und rechnet nur fuer sichtbare Fenster. */
  function initTileMotion() {
    var grid = document.querySelector('.cattiles__grid');
    if (!grid || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches) return;
    var items = [].slice.call(grid.querySelectorAll('.cattile__media')).filter(function (m) { return m.querySelector('.cattile__img'); });
    if (!items.length) return;
    var visible = [], ticking = false;
    var apply = function () {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      visible.forEach(function (m) {
        var r = m.getBoundingClientRect();
        /* p: +1 = Fenster unten ausserhalb, 0 = Fenstermitte, -1 = oben ausserhalb */
        var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
        p = Math.max(-1, Math.min(1, p));
        m.style.setProperty('--py', (-p).toFixed(3));
      });
    };
    var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(apply); } };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var i = visible.indexOf(e.target);
        if (e.isIntersecting && i < 0) visible.push(e.target);
        else if (!e.isIntersecting && i >= 0) visible.splice(i, 1);
      });
      onScroll();
    }, { rootMargin: '10% 0px 10% 0px' });
    items.forEach(function (m) { io.observe(m); });
    grid.classList.add('cattiles__grid--motion');
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    var off = function () {
      if (!mq.matches) return;
      grid.classList.remove('cattiles__grid--motion');
      window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll);
      items.forEach(function (m) { m.style.removeProperty('--py'); });
    };
    if (mq.addEventListener) mq.addEventListener('change', off);
  }

  /* ---- Hauptnavigation: Untermenue (Desktop) ----
     Oeffnen per Hover (nur mit Maus), Klick auf den Pfeil und Tastatur; Esc schliesst und setzt den Fokus auf den Pfeil zurueck;
     Klick ausserhalb oder Fokus verlassen schliesst. aria-expanded folgt dem Zustand. */
  function initNav() {
    var parents = [].slice.call(document.querySelectorAll('[data-nav-parent]'));
    if (!parents.length) return;
    var hoverOk = function () { return window.matchMedia && window.matchMedia('(hover: hover)').matches; };
    var setOpen = function (p, open) {
      p.classList.toggle('is-open', open);
      var b = p.querySelector('[data-nav-toggle]');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    var closeAll = function (except) { parents.forEach(function (p) { if (p !== except) setOpen(p, false); }); };
    parents.forEach(function (p) {
      var btn = p.querySelector('[data-nav-toggle]');
      if (!btn) return;
      /* Maus: Hover oeffnet. Ein Klick auf den Pfeil danach "pinnt" das Menue offen (statt es sofort zu schliessen), der naechste Klick schliesst. */
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = p.classList.contains('is-open');
        if (isOpen && p._hovered && !p._pinned) { p._pinned = true; return; }
        closeAll(p); p._pinned = false; setOpen(p, !isOpen);
      });
      p.addEventListener('mouseenter', function () { if (!hoverOk()) return; clearTimeout(p._navTimer); p._hovered = true; closeAll(p); if (!p.classList.contains('is-open')) { p._pinned = false; setOpen(p, true); } });
      p.addEventListener('mouseleave', function () { if (!hoverOk()) return; p._hovered = false; if (p._pinned) return; p._navTimer = setTimeout(function () { setOpen(p, false); }, 180); });
      p.addEventListener('focusout', function (e) { if (!p.contains(e.relatedTarget)) { p._pinned = false; setOpen(p, false); } });
      p.addEventListener('keydown', function (e) { if (e.key === 'Escape' && p.classList.contains('is-open')) { p._pinned = false; setOpen(p, false); btn.focus(); } });
    });
    document.addEventListener('click', function (e) { parents.forEach(function (p) { if (!p.contains(e.target)) { p._pinned = false; setOpen(p, false); } }); });
  }

  /* ---- Sortierung in Kollektionen ---- */
  function initSort() {
    var sel = document.querySelector('[data-sort-select]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---- Warenkorb-Zähler ---- */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', !n);
    });
  }
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); return c; });
  }

  /* ---- Produktseite: Varianten, Preis, Galerie, Add-to-Cart ---- */
  function initProduct(root) {
    var variantsEl = root.querySelector('[data-variants]');
    var labelsEl = root.querySelector('[data-labels]');
    var form = root.querySelector('[data-product-form]');
    if (!variantsEl || !form) return;
    var variants, labels;
    try { variants = JSON.parse(variantsEl.textContent); labels = JSON.parse(labelsEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var btn = form.querySelector('[data-add-to-cart]');
    var btnLabel = form.querySelector('[data-add-label]');
    var status = form.querySelector('[data-form-status]');
    var priceCur = root.querySelector('[data-price-current]');
    var priceCmp = root.querySelector('[data-price-compare]');
    var priceWrap = root.querySelector('.product__price .price');
    var fieldsets = form.querySelectorAll('.opt');

    function selected() {
      var vals = [];
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        vals[+fs.getAttribute('data-option-index')] = c ? c.value : null;
      });
      return vals;
    }
    function findVariant(vals) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      });
    }
    function update() {
      if (!fieldsets.length) return;
      var v = findVariant(selected());
      if (!v) {
        btn.disabled = true; btnLabel.textContent = labels.unavailable; return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btnLabel.textContent = v.available ? labels.add : labels.soldOut;
      priceCur.textContent = v.price;
      if (v.onSale) { priceCmp.textContent = v.compare; priceCmp.hidden = false; priceWrap.classList.add('price--sale'); }
      else { priceCmp.hidden = true; priceWrap.classList.remove('price--sale'); }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.mediaId) {
        var target = root.querySelector('[data-media-id="' + v.mediaId + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    /* Farbwahl mit Punkten: der gewaehlte Farbname steht klein neben der Ueberschrift (Name bleibt auch fuer Screenreader erhalten) */
    fieldsets.forEach(function (fs) {
      var out = fs.querySelector('[data-opt-chosen]');
      if (!out) return;
      fs.addEventListener('change', function () { var c = fs.querySelector('input:checked'); if (c) out.textContent = c.value; });
    });

    /* Menge +/- */
    var qty = form.querySelector('[data-qty-input]');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    /* Add-to-Cart per AJAX; ohne JS greift das normale Formular */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      status.textContent = '';
      var body = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && res.data.description || labels.error);
          return refreshCartCount();
        })
        .then(function () {
          status.textContent = labels.added;
          var a = document.createElement('a');
          a.href = '/cart';
          a.textContent = labels.viewCart;
          status.appendChild(a);
        })
        .catch(function (err) { status.textContent = err.message || labels.error; })
        .then(function () { update(); if (!fieldsets.length) btn.disabled = false; });
    });
  }

  /* ---- Warenkorbseite: Menge ändern ---- */
  function initCart() {
    var cart = document.querySelector('[data-cart]');
    if (!cart) return;
    cart.querySelectorAll('input[data-line]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        inp.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: +inp.getAttribute('data-line'), quantity: Math.max(0, parseInt(inp.value, 10) || 0) })
        }).then(function () { window.location.reload(); })
          .catch(function () { inp.disabled = false; });
      });
    });
  }

  /* ---- Zurueck-Button: kommt der Besucher von einer Seite dieses Shops, geht es per Browser-Verlauf dorthin zurueck; sonst gilt das Ziel des Links ---- */
  function initBack() {
    var links = document.querySelectorAll('[data-back]');
    if (!links.length) return;
    var fromShop = false;
    try { fromShop = !!document.referrer && new URL(document.referrer).origin === window.location.origin && window.history.length > 1; } catch (e) { fromShop = false; }
    if (!fromShop) return;
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        window.history.back();
      });
    });
  }

  /* ---- Newsletter-Fenster (V1.42): erscheint unten am Bildschirm, kurz nachdem ein Besucher "Zurueck" geklickt hat (Zurueck-Button des Themes oder
         Zurueck-Taste des Browsers) und auf der Seite davor gelandet ist. Hoechstens einmal pro Besuch; Schliessen = 14 Tage Ruhe, Anmeldung = dauerhaft.
         Nie im Warenkorb und nie im Theme-Editor. Speicher kann blockiert sein (privater Modus): dann wird einfach nichts gespeichert. ---- */
  function initNewsletterSheet() {
    var sheet = document.querySelector('[data-nl-sheet]');
    if (!sheet || (window.Shopify && window.Shopify.designMode)) return;
    var HIDE = 'pt_nl_hide', ARM = 'pt_nl_arm', SHOWN = 'pt_nl_shown';
    var st = function (kind) { return { get: function (k) { try { return window[kind].getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { window[kind].setItem(k, v); } catch (e) {} }, del: function (k) { try { window[kind].removeItem(k); } catch (e) {} } }; };
    var ls = st('localStorage'), ss = st('sessionStorage');
    var show = function () {
      if (!sheet.hidden) return;
      sheet.hidden = false; ss.set(SHOWN, '1');
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { sheet.classList.add('is-open'); }); });
    };
    var hide = function (days) {
      ls.set(HIDE, String(Date.now() + days * 86400000));
      sheet.classList.remove('is-open');
      window.setTimeout(function () { sheet.hidden = true; }, 350);
    };
    sheet.querySelector('[data-nl-close]').addEventListener('click', function () { hide(14); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) hide(14); });
    if (sheet.querySelector('[data-nl-success]')) { ls.set(HIDE, String(Date.now() + 3650 * 86400000)); show(); return; }
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-back], .page-back a') : null;
      if (a) ss.set(ARM, '1');
    }, true);
    var viaBrowserBack = function (persisted) {
      var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      return !!persisted || !!(nav && nav.type === 'back_forward');
    };
    var maybe = function (persisted) {
      var armed = ss.get(ARM) === '1';
      if (!armed && !viaBrowserBack(persisted)) return;
      ss.del(ARM);
      if (document.body.classList.contains('template-cart') || ss.get(SHOWN) === '1') return;
      if ((Number(ls.get(HIDE)) || 0) > Date.now()) return;
      window.setTimeout(show, 700);
    };
    window.addEventListener('pageshow', function (e) { if (e.persisted) maybe(true); });
    maybe(false);
  }

  /* ---- Versandhinweis auf der Startseite (V1.43): Die Woerter springen nacheinander herein, sobald das Banner im Bild ist (einmal).
         Ohne JavaScript oder mit "Bewegung reduzieren" steht der Satz einfach da. Fuer Screenreader bleibt der volle Satz als aria-label erhalten,
         die einzelnen Woerter sind ausgeblendet (aria-hidden), damit nicht Wort fuer Wort vorgelesen wird. ---- */
  function initShipNote() {
    var note = document.querySelector('.shipnote');
    if (!note || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var n = 0;
    note.querySelectorAll('.shipnote__text, .shipnote__flow').forEach(function (p) {
      var full = p.textContent.replace(/\s+/g, ' ').trim();
      p.setAttribute('aria-label', full);
      p.textContent = '';
      full.split(' ').forEach(function (word, i, all) {
        var w = document.createElement('span');
        w.className = 'shipnote__w'; w.setAttribute('aria-hidden', 'true');
        w.style.setProperty('--i', String(n++)); w.textContent = word;
        p.appendChild(w);
        if (i < all.length - 1) p.appendChild(document.createTextNode(' '));
      });
    });
    note.classList.add('is-split');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { note.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.35 });
    io.observe(note);
  }

  /* ---- Header-Video (V1.46): kleines Video oben rechts im Header. Spielt stumm in Schleife, nur solange es im Bild ist und der Header gross ist.
         Ohne JavaScript bleibt der Knopf unsichtbar (nichts Halbfertiges). Mit "Bewegung reduzieren" oder "Daten sparen" startet es nicht von allein.
         Ein Klick auf die Kachel haelt an/spielt ab (Videos ueber 5 Sekunden brauchen eine Steuerung). ---- */
  function initHeaderVideo() {
    var btn = document.querySelector('[data-hvideo]'), hdr = document.querySelector('[data-header]');
    var v = btn && btn.querySelector('video');
    if (!btn || !v) return;
    var conn = navigator.connection || {};
    var calm = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || conn.saveData === true;
    var userPaused = calm, visible = true, compact = !!(hdr && hdr.classList.contains('is-compact'));
    btn.hidden = false;
    var label = function () { var p = v.paused; btn.classList.toggle('is-paused', p); btn.setAttribute('aria-label', btn.getAttribute(p ? 'data-label-play' : 'data-label-pause')); };
    var play = function () { var r = v.play(); if (r && r.catch) r.catch(function () { /* Autoplay verweigert: Kachel zeigt das Abspiel-Symbol */ }); };
    var sync = function () { if (visible && !compact && !userPaused) play(); else if (!v.paused) v.pause(); };
    v.addEventListener('play', label); v.addEventListener('pause', label);
    btn.addEventListener('click', function () { if (v.paused) { userPaused = false; if (!compact) play(); } else { userPaused = true; v.pause(); } });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (entries) { entries.forEach(function (en) { visible = en.isIntersecting; sync(); }); }, { threshold: 0.4 }).observe(btn);
    if (hdr && 'MutationObserver' in window) new MutationObserver(function () { compact = hdr.classList.contains('is-compact'); sync(); }).observe(hdr, { attributes: true, attributeFilter: ['class'] });
    label(); sync();
  }

  /* ---- Groessentabelle: Der Button springt weich zur Tabelle in der Beschreibung. Der klebende Header wird beim Scrollen kleiner und verschiebt dabei den Inhalt;
         deshalb wird nach dem Scrollen die Endposition so nachgeholt, dass die Tabelle unter dem Header liegt. Ohne JavaScript greift der normale Anker. ---- */
  function initSizeGuide() {
    var links = document.querySelectorAll('[data-size-guide]');
    if (!links.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('size-guide');
        if (!target || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        var header = document.querySelector('[data-header]');
        var gap = 16;
        var settle = function () {
          var hb = header ? header.getBoundingClientRect().bottom : 0;
          var delta = target.getBoundingClientRect().top - (Math.max(hb, 0) + gap);
          if (Math.abs(delta) > 2) window.scrollBy({ top: delta, behavior: 'auto' });
          try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
        };
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var last = -1, still = 0, frames = 0;
        var tick = function () {
          frames++;
          var y = window.scrollY;
          still = (Math.abs(y - last) < 0.5) ? still + 1 : 0; last = y;
          if (still >= 8 || frames > 150) { settle(); window.setTimeout(settle, 450); return; }
          window.requestAnimationFrame(tick);
        };
        window.requestAnimationFrame(tick);
      });
    });
  }

  function init() {
    initReveal();
    initShipToast();
    initHeader();
    initNav();
    initBack();
    initNewsletterSheet();
    initShipNote();
    initHeaderVideo();
    initSizeGuide();
    initTileMotion();
    initSort();
    initCart();
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
